import { PatientNote, PatientNoteUpdateCommand } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsCommand, UseCqrsCommandResult } from '@dreryk/command-query-react-common';
import { Choice } from '@dreryk/watermelon';

import { NoteFormBean } from '../NoteModalCommon/NoteModalCommon';

type PatientNoteParameters = NoteFormBean & { id: PatientNote['id'] };

export const usePatientNoteUpdateCommand = (
   onSuccess: () => void
): UseCqrsCommandResult<PatientNote, PatientNoteParameters> => {
   return useCqrsCommand<PatientNote, PatientNoteParameters>(
      (parameters) => {
         const command = new PatientNoteUpdateCommand();
         command.id = parameters.id;
         command.content = Choice.withUseDefaultIfNull(parameters.content);
         return command;
      },
      {
         onSuccess: onSuccess,
      }
   );
};
